import React, { useState, useEffect } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import HomePage from './HomePage';
import InnovationPage from './InnovationPage';
import CollaborationPage from './CollaborationPage';
import CrediblePage from './CrediblePage';
import MessageFromPresident from './MessageFromPresident';
import MessageFromChairman from './MessageFromChairman';
import LeadersForStandardsAndSolutions from './LeadersForStandardsAndSolutions';
import BrokersTechnologyChampions from './BrokersTechnologyChampions';
import RaisingTheBarOnReliableServices from './RaisingTheBarOnReliableServices';
import TestNavPage from './TestNavPage';

const MAX_WIDTH = 1260;

const Pages = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = window.orientation > -1 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || width < 576;

  const setHeightAndWidthOnWindowChange = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      window.addEventListener('resize', setHeightAndWidthOnWindowChange);
    } else {
      window.removeEventListener('resize', setHeightAndWidthOnWindowChange);
    }
    return () => mounted = false;
  });

  return (
    <Router>
      <Switch>
        <Route path="/test-nav-page">
          <TestNavPage height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH}/>
        </Route>
        <Route path="/raising-the-bar-on-reliable-services">
          <RaisingTheBarOnReliableServices height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/message-from-chairman">
          <MessageFromChairman height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/message-from-president-and-ceo">
          <MessageFromPresident height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/leaders-for-standards-and-solutions">
          <LeadersForStandardsAndSolutions height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/credible">
          <CrediblePage height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/collaboration">
          <CollaborationPage height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/innovation">
          <InnovationPage height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/brokers-technology-champions">
          <BrokersTechnologyChampions height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
        <Route path="/">
          <HomePage height={height} width={width} isMobile={isMobile} MAX_WIDTH={MAX_WIDTH} />
        </Route>
      </Switch>
    </Router>
  )
}

export default Pages;
